import { cn } from 'lib/helpers/utility';

import Typography from 'components/shared/Typography/Typography';

const WEIGHT_CLASS = /(?:^|\s)font-([4-8]00)(?=\s|$)/g;

const weightFromClassName = (className) => {
  const matches = [...String(className ?? '').matchAll(WEIGHT_CLASS)];
  return matches.length ? matches[matches.length - 1][1] : undefined;
};

const DocText = ({ variant = 'p', size = 'small', className, children, ...rest }) => (
  <Typography
    variant={variant}
    size={size}
    weight={weightFromClassName(className)}
    parentClassName="block"
    className={cn('block w-full', className)}
    {...rest}>
    {children}
  </Typography>
);

export default DocText;
